import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { products } from '../data'
import { HomePath } from '../home-path'

export default function Cart() {
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
  return (
    <div className="w-full h-fit py-12">
        <div className="mxw">
            <div className="w-full h-fit py-4 text-left">
                <p className="text-3xl font-bold">Your Bag</p>
            </div>
            {products?.slice(12,14)?.map(product => (
                <Link key={product?.id} to={HomePath + `/product/${product?.id}/details`} state={product}>
                    <div className="w-full grid md:grid-cols-3 gap-4 md:gap-8 h-fit md:h-96 py-6 border-t border-gray-100 rounded-2xl px-2 my-2">
                        {/* <div className="bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url(${product?.img})` }}/> */}
                        <div className="md:col-span-1 max-h-64 md:max-h-fit flex items-center justify-center overflow-hidden">
                            <img className="h-full w-full object-cover" src={product?.img} alt="" />
                        </div>
                        <div className="md:col-span-2 space-y-1 text-gray-700">
                            <h3 className="text-lg md:text-xl capitalize font-bold">{product?.type}</h3>
                            <h3 className="capitalize text-sm md:text-md lg:text-lg">{product?.name}</h3>
                            {/* <p className="capitalize text-sm md:text-md lg:text-lg">Product off-red</p> */}
                            <p className="capitalize text-sm md:text-md lg:text-lg">Size - LG</p>
                            <p className="capitalize text-sm md:text-md lg:text-lg">Arrives Wed, Oct 19</p>
                            <div className="w-full flex items-center justify-start space-x-4 py-4">
                                <button>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-black">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                                    </svg>
                                </button>
                                <button>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-black">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                </svg>
                                </button>
                            </div>
                            <div className="w-full flex items-center justify-between">
                                <p className="">Qty: 1</p>
                                <p className="font-bold text-lg md:text-xl">${product?.price}</p>
                            </div>
                        </div>
                    </div>
                </Link>
            ))}
            <section className="py-6 border-t space-y-3">
                <div className="flex items-center justify-between text-md md:text-lg lg:text-xl">
                    <p>Subtotal:</p>
                    <p>$160</p>
                </div>
                <div className="flex items-center justify-between text-md md:text-lg lg:text-xl">
                    <p>Shipping:</p>
                    <p>Standard - Free</p>
                </div>
                <div className="flex items-center justify-between text-md md:text-lg lg:text-xl">
                    <p className="font-bold">Estimated Total:</p>
                    <p className="font-bold">$173</p>
                </div>
                <div className="flex items-center justify-end text-md md:text-lg lg:text-xl">
                    <a href={HomePath + "/checkout"} target="_blank" rel="noreferrer noopener">
                        <button className="py-2 px-4 rounded-full bg-black text-white font-medium">Checkout</button>
                    </a>
                </div>
            </section>
        </div>
    </div>
  )
}
